import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "divider divider--green" }, null, -1)
const _hoisted_3 = { class: "footer__bottom" }
const _hoisted_4 = { class: "full--width footer__bottom_text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_LKFLink = _resolveComponent("LKFLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("b", _hoisted_4, _toDisplayString(_ctx.t('footer.lkfLong')), 1),
      _createVNode(_component_LKFLink, {
        class: "footer__bottom_link",
        href: "tel:1247"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Icon, {
            class: "footer__bottom_icon",
            "icon-name": "phone"
          }),
          _createTextVNode(" 1247 ")
        ]),
        _: 1
      }),
      _createVNode(_component_LKFLink, {
        class: "footer__bottom_link",
        href: "mailto:lkf@lkf.ee"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Icon, {
            class: "footer__bottom_icon",
            "icon-name": "mail"
          }),
          _createTextVNode(" lkf@lkf.ee ")
        ]),
        _: 1
      })
    ])
  ]))
}